module.exports = __webpack_public_path__ + "static/media/Baltic_Main.37aefc2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Baltic_Main.jpg
// module id = 344
// module chunks = 0